
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-partnere",
      function () {
        return require("private-next-pages/for-partnere/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-partnere"])
      });
    }
  